import { render, staticRenderFns } from "./OfferNameInput.vue?vue&type=template&id=e2fdc132&scoped=true&"
import script from "./OfferNameInput.vue?vue&type=script&lang=js&"
export * from "./OfferNameInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fdc132",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib'
installComponents(component, {VForm})
